import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IStruxTagUtilizationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  infuseId: Types.Scalars['String']['input']
  windowDays?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type IStruxTagUtilizationQuery = {
  struxTagUtilization?: {
    windowStart: string
    windowEnd: string
    shiftHours: number
    totalHours: number
    percentDaysUsed?: number | null
    utilizationRate?: number | null
    days: Array<{
      date: string
      hours: number
      overtimeHours: number
      isWorkingDay: boolean
      isToday: boolean
    }>
  } | null
}

export const StruxTagUtilizationDocument = gql`
  query StruxTagUtilization(
    $projectId: ObjectId!
    $infuseId: String!
    $windowDays: Int
  ) {
    struxTagUtilization(
      projectId: $projectId
      infuseId: $infuseId
      windowDays: $windowDays
    ) {
      windowStart
      windowEnd
      shiftHours
      totalHours
      percentDaysUsed
      utilizationRate
      days {
        date
        hours
        overtimeHours
        isWorkingDay
        isToday
      }
    }
  }
`

/**
 * __useStruxTagUtilizationQuery__
 *
 * To run a query within a React component, call `useStruxTagUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStruxTagUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStruxTagUtilizationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      infuseId: // value for 'infuseId'
 *      windowDays: // value for 'windowDays'
 *   },
 * });
 */
export function useStruxTagUtilizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IStruxTagUtilizationQuery,
    IStruxTagUtilizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IStruxTagUtilizationQuery,
    IStruxTagUtilizationQueryVariables
  >(StruxTagUtilizationDocument, options)
}
export function useStruxTagUtilizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IStruxTagUtilizationQuery,
    IStruxTagUtilizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IStruxTagUtilizationQuery,
    IStruxTagUtilizationQueryVariables
  >(StruxTagUtilizationDocument, options)
}
export type StruxTagUtilizationQueryHookResult = ReturnType<
  typeof useStruxTagUtilizationQuery
>
export type StruxTagUtilizationLazyQueryHookResult = ReturnType<
  typeof useStruxTagUtilizationLazyQuery
>
export type StruxTagUtilizationQueryResult = Apollo.QueryResult<
  IStruxTagUtilizationQuery,
  IStruxTagUtilizationQueryVariables
>
